import { usePollingCount, notifyCountUpdated } from './usePollingCount.js'
import { endpoints } from '../services/api.js'
import { hasAdminRights } from '../constants/roles.js'

const EVENT_NAME = 'feedback-updated'

/**
 * Nombre de feedbacks en attente — n'est chargé que pour les admins.
 * Auto-refresh toutes les 60s + listener 'feedback-updated' pour rafraîchir
 * immédiatement après une action côté UI.
 */
export function useFeedbackPendingCount() {
  const { toRefs, reload } = usePollingCount({
    endpoint: endpoints.feedback.summary(),
    eventName: EVENT_NAME,
    initialState: { pendingFeedbackCount: 0 },
    gate: (user) => hasAdminRights(user?.role),
    mapResponse: (data) => ({ pendingFeedbackCount: data?.counts?.pending || 0 }),
  })
  const { pendingFeedbackCount } = toRefs()
  return { pendingFeedbackCount, reloadFeedbackCount: reload }
}

export function notifyFeedbackUpdated() {
  notifyCountUpdated(EVENT_NAME)
}
